/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'

import { useModal } from '@hashicorp/mds-react/components'
import { ABMModalContent } from 'app/[locale]/abm/_components/abm-tabs/modal-content'
import { getModalType } from 'app/[locale]/abm/_utils/get-modal-type'
import type { ReactNode, MouseEvent } from 'react'
import { usePostHog } from 'posthog-js/react'
import { vercelSplit } from '@web/cms'
import s from './abm-tabs-modal-button.module.css'

const ABMModalButton = ({
	modalId,
	href,
	onClick,
	children,
}: {
	modalId: string
	href: string
	onClick?: (event: MouseEvent<HTMLButtonElement>) => void
	children: ReactNode
}) => {
	const { openModal } = useModal()
	const posthog = usePostHog()
	const resourceType = getModalType(vercelSplit(href))

	return (
		<button
			className={s.modalButton}
			type="button"
			onClick={(event) => {
				onClick?.(event)
				window.location.hash = modalId
				openModal(<ABMModalContent href={href} />)
				posthog?.capture('abm:modal_open', {
					resource_name: modalId,
					resourceType,
					entry_method: 'click',
				})
			}}
		>
			{children}
		</button>
	)
}

export { ABMModalButton }
